import { ECurrency } from '../../types/enums'

export const getCurrencyFractionDigits = (currency: ECurrency): number => {
  const decimalsForCurrency: Partial<Record<ECurrency, number>> = {
    [ECurrency.TON]: 9,
    [ECurrency.USDT]: 6,
    [ECurrency.JPY]: 0,
    [ECurrency.COIN]: 0,
  }
  return decimalsForCurrency[currency] ?? 2
}
